<template>
    <div class="ecommerce-application mt-70 mb-4">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-10 col-xl-8">
                    <div class="section-title title-01 mb-70">

                        <!-- Title -->
                        <h2 class="h2-md">E-BOOKS</h2>
                        <!-- Text -->
                        <p class="p-xl">Just 3 simple steps to start using Creditfixrr.com.</p>
                    </div>
                </div>
            </div>
            <section id="wishlist" class="grid-view wishlist-items align-content-center">
                <!-- link not set  -->
                    <div class="card ecommerce-card">
                        <div class="item-img text-center  mx-auto">
                            <a href="https://sowl.co/s/2EDh1" target="_blank">
                                <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-chatgpt-ebook-right.png"
                                    class="img-fluid"
                                    alt="number-one-credit-repair-ebook-you-are-the-creditfixrr" style="width:200px;"/>
                            </a>
                        </div>
                        <div class="card-body">
                            <div class="item-wrapper">
                                <div class="review-rating ico-15 yellow-color">
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                </div>
                                <div class="item-cost">
                                    <h6 class="item-price">$19.97</h6>
                                </div>
                            </div>
                            <div class="item-name" style="-webkit-line-clamp: unset !important;">
                                <a href="https://sowl.co/s/2EDh1" style="-webkit-line-clamp: unset !important; font-size:small;color: #4b9a5e;" target="_blank">ChatGPT with Creditfixrr.com</a>
                            </div>

                        </div>
                        <div class="item-options text-center">
                            <a href="https://sowl.co/s/2EDh1" type="button" class="btn btn-primary btn-cart" target="_blank">
                                <i data-feather="shopping-bag"></i>
                                <span class="add-to-cart">Buy Now</span>
                            </a>
                        </div>
                    </div>
                    <!--  -->
                    <div class="card ecommerce-card">
                        <div class="item-img text-center  mx-auto">
                            <a href="https://sowl.co/s/HbC6A" target="_blank">
                                <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-100-dispute-reasons-ebook-right.png"
                                    class="img-fluid"
                                    alt="best-student-loan-removal-guide" style="width:200px;"/>
                            </a>
                        </div>
                        <div class="card-body">
                            <div class="item-wrapper">
                                <div class="review-rating ico-15 yellow-color">
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                </div>
                                <div class="item-cost">
                                    <h6 class="item-price">$19.97</h6>
                                </div>
                            </div>
                            <div class="item-name">
                                <a href="https://sowl.co/s/HbC6A" style="-webkit-line-clamp: unset !important;font-size:small;color: #4b9a5e;" target="_blank">100+ Dispute Reasons</a>
                            </div>

                        </div>
                        <div class="item-options text-center">
                            <a href="https://sowl.co/s/HbC6A" type="button" class="btn btn-primary btn-cart" target="_blank">
                                <i data-feather="shopping-bag"></i>
                                <span class="add-to-cart">Buy Now</span>
                            </a>
                        </div>
                    </div>
                    <div class="card ecommerce-card">
                        <div class="item-img text-center  mx-auto">
                            <a href="https://sowl.co/s/bhEaCg" target="_blank">
                                <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-business-funding-ebook-right.png"
                                    class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                            </a>
                        </div>
                        <div class="card-body">
                            <div class="item-wrapper">
                                <div class="review-rating ico-15 yellow-color">
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                </div>
                                <div class="item-cost">
                                    <h6 class="item-price">$49.97</h6>
                                </div>
                            </div>
                            <div class="item-name">
                                <a href="https://sowl.co/s/bhEaCg" style="-webkit-line-clamp: unset !important;font-size:small;color: #4b9a5e;" target="_blank"> Business Structure & Funding</a>
                            </div>

                        </div>
                        <div class="item-options text-center">
                            <a href="https://sowl.co/s/bhEaCg" type="button" class="btn btn-primary btn-cart" target="_blank">
                                <i data-feather="shopping-bag"></i>
                                <span class="add-to-cart">Buy Now</span>
                            </a>
                        </div>
                    </div>
                    <div class="card ecommerce-card">
                        <div class="item-img text-center  mx-auto">
                            <a href="https://sowl.co/s/92Sgo" target="_blank">
                                <img src="https://creditrepair-development.nyc3.digitaloceanspaces.com/assets/creditfixrr-student-loan-removal-ebook-left.png"
                                    class="img-fluid" alt="best-student-loan-removal-guide" style="width:200px;"/>
                            </a>
                        </div>
                        <div class="card-body">
                            <div class="item-wrapper">
                                <div class="review-rating ico-15 yellow-color">
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                    <span class="flaticon-star-1"></span>
                                </div>
                                <div class="item-cost">
                                    <h6 class="item-price">$39.97</h6>
                                </div>
                            </div>
                            <div class="item-name">
                                <a href="https://sowl.co/s/92Sgo" style="-webkit-line-clamp: unset !important;font-size:small;color: #4b9a5e;" target="_blank"> Student Loan Removal Guide</a>
                            </div>
                        </div>
                        <div class="item-options text-center">

                            <a href="https://sowl.co/s/92Sgo" type="button" class="btn btn-primary btn-cart" target="_blank">
                                <i data-feather="shopping-bag"></i>
                                <span class="add-to-cart">Buy Now</span>
                            </a>
                        </div>
                    </div>
            </section>
        </div>
    </div>

</template>
<script>
import {ref} from 'vue'

export default{
    components:{
    },
    setup(){
        return{
            landing_data: ref({})
        }
    },
    mounted(){
    }
}
</script>

<style>
.ecommerce-application .grid-view .ecommerce-card .item-options {
    display: flex;
    flex-wrap: wrap;
    background: #4b9a5e;
}
.ecommerce-application .grid-view .ecommerce-card .item-options {
    display: flex;
    flex-wrap: wrap;
    background: #4b9a5e;
}
</style>
